import React from 'react';
import { Pagination } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const Pager = (props) => {
  const { totalPages, currentPage, setCurrentPage } = props;

  const _setCurrentPage = (index) => {
    setCurrentPage(index - 1);
  };

  return (
    <Pagination
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      currentPage={currentPage + 1}
      setCurrentPage={_setCurrentPage}
      pageRangeDisplayed={totalPages > 6 ? 2 : 5}
      marginPagesDisplayed={totalPages > 6 ? 1 : 0}
      previousLabel={<div className="Pagination__previous"><i className="icon-before icon-arrow" /></div>}
      nextLabel={<div className="Pagination__next"><i className="icon-after icon-arrow" /></div>}
    />
  );
};

export default Pager;
